import { render, staticRenderFns } from "./AlipayRealname.vue?vue&type=template&id=c017d8c0&scoped=true"
import script from "./AlipayRealname.vue?vue&type=script&lang=js"
export * from "./AlipayRealname.vue?vue&type=script&lang=js"
import style0 from "./AlipayRealname.vue?vue&type=style&index=0&id=c017d8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c017d8c0",
  null
  
)

export default component.exports